import { ProductPackageSet } from '@models/products'
import { ProductPackageKind } from '@modules/product-package/models'

export type ProductPackageOffer = 'winter' | 'christmas'

export const getProductPackageOffer = (pathname: string, search = ''): ProductPackageOffer | undefined => {
  if (/^\/product-package\/winter(?:\/|$)/.test(pathname)) return 'winter'
  if (/^\/product-package\/voucher(?:\/|$)/.test(pathname)) return 'christmas'
  if (pathname.startsWith('/product-package/subscriptions/PRODUCT_PACKAGE_VOUCHER/')) {
    const offer = new URLSearchParams(search).get('pms_offer')
    if (offer === 'winter' || offer === 'christmas') return offer
  }
  return undefined
}

export const filterProductPackageSets = (
  sets: ProductPackageSet[],
  kind: ProductPackageKind,
  offer?: ProductPackageOffer,
) => sets.filter(set => set.kind === kind && (!offer || !!set.is_winter === (offer === 'winter')))
